import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import defaultGetWasChanged from '../defaultGetWasChanged';
import defaultGetError from '../defaultGetError';
import { constructFieldKey } from './constructFieldKey';

/**
 * This function takes the form's field definitions
 * as well as the current React state (`fieldStates`),
 * and computes the `fields` object that is returned
 * by the `useForm` hook.
 */

export function getAugmentedFieldStates(fields, createFieldsForEachId, fieldStates, setFieldStates) {
  var augmentedFieldStates = {};
  Object.entries(fields).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      unknownField = _ref2[1];
    function getFieldObject(fieldKey, id) {
      var fieldDef = unknownField;
      var _fieldDef$getError = fieldDef.getError,
        getError = _fieldDef$getError === void 0 ? defaultGetError : _fieldDef$getError,
        _fieldDef$getWasChang = fieldDef.getWasChanged,
        getWasChanged = _fieldDef$getWasChang === void 0 ? defaultGetWasChanged : _fieldDef$getWasChang;
      var fieldState = fieldStates[fieldKey];
      if (!fieldState) {
        var defaultValue = id ? fieldDef.getDefaultValue(id) : fieldDef.getDefaultValue();
        fieldState = {
          defaultValue: defaultValue,
          value: defaultValue,
          changedValue: undefined,
          wasChanged: false
        };
      }
      var error = getError(fieldState.value, fieldDef);
      var fieldObject = _objectSpread(_objectSpread({}, fieldState), {}, {
        error: error,
        isValid: !error,
        set: function set(newValue) {
          return setFieldStates(function (prevState) {
            var value = newValue instanceof Function ? newValue(fieldState.value) : newValue;
            var wasChanged = getWasChanged(fieldState.defaultValue, value);
            return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, fieldKey, _objectSpread(_objectSpread({}, fieldState), {}, {
              value: value,
              wasChanged: wasChanged,
              changedValue: wasChanged ? value : undefined
            })));
          });
        },
        reset: function reset() {
          return setFieldStates(function (prevState) {
            var defaultValue = id ? fieldDef.getDefaultValue(id) : fieldDef.getDefaultValue();
            return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, fieldKey, {
              value: defaultValue,
              defaultValue: defaultValue,
              wasChanged: false,
              changedValue: undefined
            }));
          });
        }
      });
      return fieldObject;
    }
    augmentedFieldStates[key] = createFieldsForEachId ? function (id) {
      return getFieldObject(constructFieldKey(key, id), id);
    } : getFieldObject(key);
  });
  return augmentedFieldStates;
}